/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash f45f06ac478023b9a1146960ff0b0da6 */

import { ConcreteRequest } from "relay-runtime";

export type CountryCode = "AE" | "AR" | "AT" | "AU" | "BE" | "BG" | "BR" | "CA" | "CH" | "CL" | "CN" | "CO" | "CR" | "CZ" | "DE" | "DK" | "EC" | "EE" | "EG" | "ES" | "FI" | "FL" | "FR" | "GB" | "GR" | "GT" | "HR" | "HU" | "IE" | "IN" | "IT" | "JP" | "KE" | "KR" | "LT" | "LU" | "LV" | "MA" | "MX" | "MY" | "NL" | "NO" | "NZ" | "PA" | "PE" | "PL" | "PT" | "RO" | "SA" | "SE" | "SG" | "SI" | "SK" | "TN" | "TR" | "UA" | "UK" | "UM" | "US" | "VG" | "VI" | "ZA" | "%future added value";
export type DigitalRiverCreditCardBrand = "AMERICAN_EXPRESS" | "DISCOVER" | "MASTERCARD" | "VISA" | "%future added value";
export type DigitalRiverPaymentType = "CREDIT_CARD" | "PAYPAL" | "%future added value";
export type DigitalRiverBillingUpdateInput = {
    defaultBillTo?: DigitalRiverBillToInput | null | undefined;
    defaultShipTo?: DigitalRiverShipToInput | null | undefined;
    isPrimaryPaymentSource?: boolean | null | undefined;
    paymentSourceId?: string | null | undefined;
    taxCertificate?: DigitalRiverTaxCertificateInput | null | undefined;
};
export type DigitalRiverBillToInput = {
    address: AddressCreateInput;
    email?: string | null | undefined;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    organization?: string | null | undefined;
};
export type AddressCreateInput = {
    addressLine1: string;
    addressLine2?: string | null | undefined;
    city: string;
    contactName?: string | null | undefined;
    countryCode: CountryCode;
    mailingAddressName?: string | null | undefined;
    stateProvinceRegionCode: string;
    zipPostalCode: string;
};
export type DigitalRiverShipToInput = {
    address: AddressCreateInput;
    email?: string | null | undefined;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    organization?: string | null | undefined;
};
export type DigitalRiverTaxCertificateInput = {
    companyName: string;
    digitalRiverFileId: string;
    endDate: string;
    startDate: string;
    taxAuthority: string;
};
export type PaymentMethodFormDigitalRiverBillingUpdateMutationVariables = {
    digitalRiverBillingId: string;
    input: DigitalRiverBillingUpdateInput;
};
export type PaymentMethodFormDigitalRiverBillingUpdateMutationResponse = {
    readonly digitalRiverBillingUpdate: {
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
            readonly field: ReadonlyArray<string | null> | null;
        }> | null;
        readonly digitalRiverBilling: {
            readonly billingCustomerNumber: string | null;
            readonly paymentSources: ReadonlyArray<{
                readonly paymentSourceId: string | null;
                readonly clientSecret: string | null;
                readonly paymentSessionId: string | null;
                readonly payPalBillingToken: string | null;
                readonly type: DigitalRiverPaymentType | null;
                readonly creditCard: {
                    readonly lastFourDigits: string | null;
                    readonly expirationMonth: number | null;
                    readonly brand: DigitalRiverCreditCardBrand | null;
                    readonly expirationYear: number | null;
                } | null;
                readonly billTo: {
                    readonly firstName: string | null;
                    readonly lastName: string | null;
                    readonly organization: string | null;
                    readonly email: string | null;
                    readonly address: {
                        readonly addressLine1: string | null;
                        readonly addressLine2: string | null;
                        readonly city: string | null;
                        readonly stateProvinceRegionCode: string | null;
                        readonly zipPostalCode: string | null;
                        readonly countryCode: CountryCode | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type PaymentMethodFormDigitalRiverBillingUpdateMutation = {
    readonly response: PaymentMethodFormDigitalRiverBillingUpdateMutationResponse;
    readonly variables: PaymentMethodFormDigitalRiverBillingUpdateMutationVariables;
};



/*
mutation PaymentMethodFormDigitalRiverBillingUpdateMutation(
  $digitalRiverBillingId: ID!
  $input: DigitalRiverBillingUpdateInput!
) {
  digitalRiverBillingUpdate(digitalRiverBillingId: $digitalRiverBillingId, input: $input) {
    errors {
      message
      field
    }
    digitalRiverBilling {
      billingCustomerNumber
      paymentSources {
        paymentSourceId
        clientSecret
        paymentSessionId
        payPalBillingToken
        type
        creditCard {
          lastFourDigits
          expirationMonth
          brand
          expirationYear
        }
        billTo {
          firstName
          lastName
          organization
          email
          address {
            addressLine1
            addressLine2
            city
            stateProvinceRegionCode
            zipPostalCode
            countryCode
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "digitalRiverBillingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "digitalRiverBillingId",
    "variableName": "digitalRiverBillingId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Error",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingCustomerNumber",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "DigitalRiverPaymentSource",
  "kind": "LinkedField",
  "name": "paymentSources",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentSourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientSecret",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentSessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payPalBillingToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DigitalRiverCreditCard",
      "kind": "LinkedField",
      "name": "creditCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastFourDigits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expirationMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "brand",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expirationYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DigitalRiverBillTo",
      "kind": "LinkedField",
      "name": "billTo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "organization",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addressLine1",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addressLine2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stateProvinceRegionCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipPostalCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentMethodFormDigitalRiverBillingUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DigitalRiverBillingPayload",
        "kind": "LinkedField",
        "name": "digitalRiverBillingUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DigitalRiverBilling",
            "kind": "LinkedField",
            "name": "digitalRiverBilling",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaymentMethodFormDigitalRiverBillingUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DigitalRiverBillingPayload",
        "kind": "LinkedField",
        "name": "digitalRiverBillingUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DigitalRiverBilling",
            "kind": "LinkedField",
            "name": "digitalRiverBilling",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f45f06ac478023b9a1146960ff0b0da6",
    "metadata": {},
    "name": "PaymentMethodFormDigitalRiverBillingUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '064c5d26c8e2a276aa63202a12bed7b6';
export default node;
